import React, { FC } from 'react'
import cx from 'classnames'

import { BannerProps } from '../../components/Banner'
import { DeclarationStepperProps } from '../../components/DeclarationStepper'
import BoxedContent from '../../components/BoxedContent'

import * as SC from './styled'

export type DeclarationFormLayoutProps = {
  className?: string
  children?: React.ReactNode
  banner?: BannerProps
  stepper?: DeclarationStepperProps
}

const DeclarationFormLayout: FC<DeclarationFormLayoutProps> = ({
  children,
  className,
  banner,
  stepper,
}) => {
  return (
    <SC.Container className={cx(className)}>
      {banner && <SC.Banner {...banner} />}
      <BoxedContent>
        {stepper && <SC.Stepper {...stepper} />}
        {children}
      </BoxedContent>
    </SC.Container>
  )
}

export default DeclarationFormLayout
